$(function() {
  localeIsFr = $('html').attr('lang') == 'fr';
  
  $('.open-brochure-form').on('click', function(e) {
    e.stopPropagation();

    $('.toiture-brochure-popup').addClass("active");
  });

  $(document).keyup(function(e) {
    if (e.which == 27) {
      closeForm();
    }
  });

  $(document).on('click', '.icon-close-btn', function(){
    closeForm();
  });

  $(document).on('click', '#toiture-brochure-submit', function(e) {
    var that = $(this),
    form = that.parents('#toiture-brochure-form'),
    formParsley = form.parsley();

    formParsley.validate();

    if (formParsley.isValid()) {
      that.attr('disabled', 'disabled');
      grecaptcha.execute();
    }
    else {
      form.find('.notif').html(localeIsFr ? 
        '<p class="alert">Votre adresse courriel n\'est pas valide.</p>' : 
        '<p class="alert">Your email address is invalid.</p>');
      form.find('.notif p').addClass('alert-error');
    }
  });
});

function closeForm() {
  form = $('#toiture-brochure-form');
  form.parsley().reset()
  form.find('.email-input').val('');
  form.find('.notif').html('');
  $('.toiture-brochure-popup').removeClass("active");
}

// Brochure form
function sendToitureBrochureForm() {
  var form = $('#toiture-brochure-form'),
  url = form.attr('action'),
  method = form.attr('method'),
  data = form.serialize();

  $.ajax({
    url: url,
    type: method,
    dataType: 'json',
    data: data
  })
  .done(function(data) {
    if (data.success) {
      closeForm();
      window.open('/assets/pdf/RML_Depliant_Toitures.pdf', '_blank');
    }
    else {
      form.find('.notif').html('<p class="alert">' + data.message + '</p>');
      form.find('.notif p').removeClass('.alert-success').addClass('alert-error')
    }

  })
  .fail(function(data) {
    form.find('.notif').html(localeIsFr ? 
      '<p class="alert">Impossible d\'envoyer le courriel. Veuillez réessayer.</p>' :
      '<p class="alert">Unable to send email. Please try again.</p>');
    form.find('.notif p').addClass('alert-error')
  })
  .always(function(){
    form.find('#toiture-brochure-submit').removeAttr('disabled');
  });
}